import { TenantStatus } from "../../models/tenant_old.js";
import { Tabs } from "../UI/Tabs/Tabs";
import ShowCandidatList from "./ShowCandidatList";

export default function CandidatList({ tenants, isLoading, onAdd }) {
  const candidats = tenants.filter(
    (tenant) => tenant.status === TenantStatus.Candidat.status,
  );

  const candidatsArchives = tenants.filter(
    (tenant) => tenant.status === TenantStatus.CandidatArchive.status,
  );
  return (
    <Tabs id="candidat-list" defaultValue="candidats">
      <div className="container bg-blue paddingT10 border-blue">
        <div className="content">
          <Tabs.List>
            <Tabs.Tab value="candidats">
              Candidats ({candidats.length})
            </Tabs.Tab>
            <Tabs.Tab value="candidatsArchives">Candidats archivés</Tabs.Tab>
          </Tabs.List>
        </div>
      </div>
      <div className="blueSpace"></div>
      <div className="content">
        <Tabs.Panel value="candidats">
          <ShowCandidatList
            tenants={candidats}
            isLoading={isLoading}
            onAdd={onAdd}
          />
        </Tabs.Panel>
        <Tabs.Panel value="candidatsArchives">
          <ShowCandidatList
            tenants={candidatsArchives}
            isLoading={isLoading}
            isArchived
          />
        </Tabs.Panel>
      </div>
    </Tabs>
  );
}
